import axios from "axios"
import { BRIDGE_URL, EXPIRY_TIME } from "./constants"


// Fetch JWT token from the server
export const fetchJWT = async () => {

    try {

        const jwt = localStorage.getItem("oss-jwt")
        const lastCall = localStorage.getItem("oss-jwt-lastcall")

        // If JWT token exists and is not expired, return it
        if(jwt && lastCall && (Date.now() - lastCall) < EXPIRY_TIME) return jwt

        // If JWT token doesn't exist, fetch new JWT
        const URL = process.env.REACT_APP_JWT_URL
        if(!URL) throw new Error("URL Not found")

        const res = await axios.get(URL)
        if(res?.data?.status === "success") {
            localStorage.setItem("oss-jwt", res?.data?.token)
            localStorage.setItem("oss-jwt-lastcall", Date.now()) // Update timestamp 
        }

        return res?.data?.token

    } catch (err) {
        console.log(err)
    }

}


// Fetch access token using JWT token from the server
export const fetchAccessToken = async () => {

    try {

        const jwt = await fetchJWT()
        const token = localStorage.getItem("oss-token")
        const lastCall = localStorage.getItem("oss-token-lastcall")

        // If access token exists and is not expired, return it
        if(token && lastCall && (Date.now() - lastCall) < EXPIRY_TIME) return token

        const URL = `${BRIDGE_URL('services/oauth2/token', true)}`
        if(!URL) throw new Error("URL Not found")

        const headers = {
            "Content-Type": "application/json"
        }

        const body = {
            grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
            assertion: jwt,
        }

        const res = await axios.post(URL, body, { headers })
        
        if(res.status === 200) {
            // Set access_token in localStorage
            localStorage.setItem("oss-token", res?.data?.access_token)
            // Set timestamp in localStorage
            localStorage.setItem("oss-token-lastcall", Date.now())
            // Set instance_url in localStorage
            localStorage.setItem("oss-instance-url", res?.data?.instance_url)

            // Reload the page
            window.location.reload();

            return res?.data?.access_token
        }
        

    } catch (err) {
        console.log(err)
    }

}